jQuery(function() {
    jQuery( '.js-feature-hotspots-container' ).on( 'click', '.js-feature-hotspots-hotspot', function ( event ) {
        if ( Math.max( jQuery( window ).width(), window.innerWidth ) > e4.settings.breakpoint.sm ) {
            event.preventDefault();
            if ( jQuery( this ).is( '.show' ) ) {
                jQuery( '.js-feature-hotspots-hotspot' ).removeClass( 'show' );
            }
            else {
                jQuery( '.js-feature-hotspots-hotspot' ).removeClass( 'show' );
                jQuery( this ).addClass( 'show' );
            }
        }
        else {
            var intScrollTarget = jQuery( '#' + jQuery( this ).attr( 'id' ).replace( 'hotspot_', 'feature-card-' ) ).offset().top - 100;
            e4.scrollToAnchor.animate( intScrollTarget );
        }
    } ).on( 'click', '.feature-hotspots-image', function () {
        jQuery( '.js-feature-hotspots-hotspot' ).removeClass( 'show' );
    } );
});
